import { SkinModel, Skin, SkinImage } from '@/core/interfaces';

export const BuySkinResponseMapper = (skin: SkinModel): Skin => {
	const cover: string = `${skin.url}cover.png`;
	const images: SkinImage[] = [];

	const numImages = parseInt(process.env.VITE_NUM_LEVELS_AVAILABLE!);

	for (let index = 1; index <= numImages; index++) {
		let url: string = '';
		if (skin && skin.url && typeof index !== 'undefined') {
			url = `${skin.url}${index}.${skin.imageType}`;
		} else {
			console.error('Invalid item or index.');
		}

		images.push({
			image: url,
		});
	}

	return {
		id: skin.id,
		name: skin.name,
		cover: cover,
		price: skin.diamondsPrice,
		owned: skin.userPurchased,
		selected: skin.skinSelected,
		expired: skin.isExpired ? skin.isExpired : false,
		images: images,
		imageExtension: skin.imageType,
	};
};
